import { useCallback } from 'react'
import { getDisplayLabel, NOT_APPLICABLE, useSubcategories } from '~/entities/categories'
import type { CategoryDescriber } from '../lib'

function part(label: string | undefined): string | null {
  return label && label !== NOT_APPLICABLE ? label : null
}

/** A category slug with its display label, description and parts, from `/categories`. */
export function useCategoryDescriber(): CategoryDescriber {
  const subcategories = useSubcategories()

  return useCallback(
    (slug) => {
      if (!slug) return { slug: null, label: null, description: null, parts: null }
      const subcategory = subcategories.find((item) => item.label === slug)
      if (!subcategory) {
        return { slug, label: getDisplayLabel(slug), description: null, parts: null }
      }
      const { phase, outcome, reason } = subcategory.metadata
      return {
        slug,
        label: subcategory.displayLabel || getDisplayLabel(slug),
        description: subcategory.description || null,
        parts: {
          phase: part(phase.label),
          outcome: part(outcome.label),
          reason: part(reason.label),
        },
      }
    },
    [subcategories],
  )
}
